(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-place', {
            parent: 'entity',
            url: '/event-place?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventPlace.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-place/event-places.html',
                    controller: 'EventPlaceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventPlace');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-place-detail', {
            parent: 'entity',
            url: '/event-place/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventPlace.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-place/event-place-detail.html',
                    controller: 'EventPlaceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventPlace');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventPlace', function($stateParams, EventPlace) {
                    return EventPlace.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-place.new', {
            parent: 'event-place',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-dialog.html',
                    controller: 'EventPlaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('event-place');
                });
            }]
        })
        .state('event-place.edit', {
            parent: 'event-place',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-dialog.html',
                    controller: 'EventPlaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventPlace', function(EventPlace) {
                            return EventPlace.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-place.delete', {
            parent: 'event-place',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-delete-dialog.html',
                    controller: 'EventPlaceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventPlace', function(EventPlace) {
                            return EventPlace.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
